import { Typography } from "@mui/material";
function JobDetailTitle({ sx = { fontSize: "1.17em", my: "1em" }, children }) {
  return (
    <Typography fontWeight={"bold"} variant="subtitle2" sx={sx}>
      {children}
    </Typography>
  );
}

export default JobDetailTitle;
